export interface User {
  id: number;
  username: string;
  status: string;
  role: Role[];
  description: string;
  createdAt: string;
  updatedAt: string;
}

export interface Role {
  code: RoleEnum;
  createdAt: string;
  description: string;
  function: string[];
  id: string;
  updatedAt: string;
}

export enum RoleEnum {
  Admin = 'ADMIN',
  Editor = 'EDITOR',
  Dashboard = 'DASHBOARD',
}

export const roleValues = {
  [RoleEnum.Dashboard]: 1 << 0, // 001
  [RoleEnum.Editor]: 1 << 1, // 010
  [RoleEnum.Admin]: 1 << 2, // 100
}

export interface Function {
  id: number;
  endpoint: string;
  method: string;
  description: string;
  status: string;
  protect: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BaseRequest<T> {
  [key: string | number | symbol]: T;
}

export interface BaseResponse<T> {
  serverTime: string;
  service: string;
  requestId: string;
  code: string;
  message: string;
  pageInfo: PaginationResponse;
  data: T;
}

export interface PaginationRequest {
  pageNo?: number;
  pageSize?: number;
  sort?: string;
}

export interface PaginationResponse {
  pageNo: number;
  pageSize: number;
  totalCount: number;
  totalPage: number;
}

export interface ApiError {
  code: string;
  message: string;
}

export type ClientEnvParams = {
  'X-Request-ID': string;
  'X-Client-IP': string;
  'X-Client-Time': string;
  'X-Client-Timezone': string;
  'X-Application-Version': string;

  'X-Device-ID'?: string;
  'X-Device-Name'?: string;
  'X-Device-Type'?: string;
  'X-Language'?: string;
};
